import { logger } from "utils/logger";
import {
  Box,
  Select,
  SegmentedControl,
  Center,
  MultiSelect,
  Group,
  Button,
  Text,
  Divider,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useState, useEffect } from "react";
import { getCaptureCataglogues } from "utils/helper";
import FormInputWrapper from "../formInputWrapper/FormInputWrapper";
import { FlagRating, ComparisonOperators } from "utils/constants";
import StarRating from "../starRating/StarRating";
import { FlagIcon } from "../flagToggle/FlagIcon";
import { FlagIconReject } from "../flagToggle/FlagIconReject";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles((theme) => ({
  container: {},
  flagIcon: {
    size: 14,
    stroke: theme.colors.gray[6],
    fill: theme.colors.gray[6],
    "&:hover": {
      stroke: theme.colors.gray[5],
      fill: theme.colors.gray[5],
    },
    "&.selected": {
      stroke: theme.colors.green[5],
      fill: theme.colors.green[5],
    },
    "&.reject-flg.selected": {
      stroke: theme.colors.pink[6],
      fill: theme.colors.pink[6],
    },
  },
}));

const CaptureFilterPanel = ({
  onCancel,
  onApply,
  filter,
  filterItems,
  styleCodes,
  showCaptureDate = true,
  showStyleCodes = true,
  showTags = true,
  filterFields = [
    {
      label: "Flag",
      value: "flag",
    },
    {
      label: "Rating",
      value: "rating",
    },
    {
      label: "Tags",
      value: "tags",
    },
  ],
}) => {
  const LABEL_WIDTH = "80px";
  const [tags, setTags] = useState([]);
  const [catalogues, setCatalogues] = useState([]);
  const [styleCode, setStylecode] = useState("");
  const { classes } = useStyles();
  const form = useForm({
    initialValues: {
      styles: [],
      tags: [],
      status: {
        taskStatus: [],
      },
      starComparison: ComparisonOperators.EQUAL,
      ...filter,
    },
  });

  useEffect(() => {
    var items = getCaptureCataglogues().map((item, idx) => {
      return { label: item.label, value: idx };
    });
    setCatalogues(items);

    if (filterItems.tags) {
      setTags(
        Object.keys(filterItems.tags).map((val) => {
          return { label: val, value: val };
        })
      );
    }
  }, []);

  useEffect(() => {
    if (filter && form) {
      form.setValues({
        styles: [],
        tags: [],
        status: {
          taskStatus: [],
        },
        starComparison: ComparisonOperators.EQUAL,
        ...filter,
      });
      // if (filter.tags && Array.isArray(filter.tags)) {
      //     const tmpTags = filter.tags.map((val) => {
      //         return { label: val, value: val };
      //     });
      //     setTags([...tmpTags]);
      // }
    }

    logger.log(filter);
  }, [filter]);

  const filterField = (field) => {
    switch (field.value) {
      case "flag":
        return (
          <FormInputWrapper
            label="Flag"
            id="input-status"
            labelWidth={LABEL_WIDTH}
          >
            <SegmentedControl
              {...form.getInputProps("sak")}
              data={[
                {
                  value: FlagRating.FLAG_SELECT,
                  label: (
                    <Center>
                      <FlagIcon size={12} className={classes.flagIcon} />
                    </Center>
                  ),
                },
                {
                  value: FlagRating.FLAG_KILL,
                  label: (
                    <Center>
                      <FlagIconReject size={12} className={classes.flagIcon} />
                    </Center>
                  ),
                },
                {
                  value: "-1",
                  label: (
                    <Center>
                      <Box style={{ marginLeft: 0 }}>
                        <Text size={"sm"}>All</Text>
                      </Box>
                    </Center>
                  ),
                },
              ]}
            />
            {/* <FlagToggle /> */}
          </FormInputWrapper>
        );
      case "rating":
        return (
          <FormInputWrapper
            label="Rating"
            id="input-rating"
            labelWidth={LABEL_WIDTH}
          >
            <Group>
              <Select
                comboboxProps={{ withinPortal: false }}
                data={[
                  { label: "[ = ] equals", value: ComparisonOperators.EQUAL },
                  {
                    label: "[ <> ] not equal",
                    value: ComparisonOperators.NOT_EQUAL,
                  },
                  {
                    label: "[ > ] greater than",
                    value: ComparisonOperators.GREATER_THAN,
                  },
                  {
                    label: "[ < ] less than",
                    value: ComparisonOperators.LESS_THAN,
                  },
                  {
                    label: "[ >= ] greater than or equal",
                    value: ComparisonOperators.GREATER_THAN_OR_EQUAL,
                  },
                  {
                    label: "[ <= ] less than or equal",
                    value: ComparisonOperators.LESS_THAN_OR_EQUAL,
                  },
                ]}
                placeholder="Comparison"
                style={{ width: "250px" }}
                portalProps={{ target: document.body }}
                {...form.getInputProps("starComparison")}
              />

              <StarRating
                onChange={(val) => form.setFieldValue("star", val.toString())}
                rating={form.values.star}
              />
            </Group>
          </FormInputWrapper>
        );
      case "tags":
        return (
          <FormInputWrapper
            label="Tags"
            id="input-tags"
            labelWidth={LABEL_WIDTH}
          >
            {/* <TagInput
                        {...form.getInputProps('tags')}
                        onChange={(val) => {
                            setTags([...val.map((item) => ({ value: item, label: item }))]);
                            form.setFieldValue('tags', val);
                        }}
                    /> */}
            <MultiSelect
              data={tags}
              searchable
              creatable
              comboboxProps={{ withinPortal: false }}
              // value={form.getInputProps('tags')}
              getCreateLabel={(query) => `+ Create ${query}`}
              onCreate={(query) => {
                const item = { value: query, label: query };

                setTags((current) => [...current, item]);

                return item;
              }}
              placeholder="Type to enter Tags"
              {...form.getInputProps("tags")}
            />
          </FormInputWrapper>
        );
      case 'hasAnnotations':
        return (<FormInputWrapper label={field.label} id="input-hasAnnotations" labelWidth={LABEL_WIDTH}>
          <SegmentedControl
            {...form.getInputProps("hasAnnotations")}
            data={[
              { label: "All", value: "" },
              { label: "Yes", value: "1" },
              { label: "No", value: "0" },
            ]}
          />
          </FormInputWrapper>
        )
      default:
        return null;
    }
  };

  return (
    <Box shadow="xs" style={{ width: "100%" }}>
      <form onSubmit={form.onSubmit((values) => onApply(values))}>
        {/* {showCaptureDate ? (
                    <FormInputWrapper label='Capture Date' id='input-captureDate' labelWidth={LABEL_WIDTH}>
                        <Select data={catalogues} placeholder='All' {...form.getInputProps('catalogue')} />
                    </FormInputWrapper>
                ) : null} */}

        {/* 
                        <FormInputWrapper label='Machines' id='input-machines' labelWidth={LABEL_WIDTH}>
                          <MultiSelect
                              data={aggData?.machines?aggData.machines:[]}
                              placeholder="All"
                              {...form.getInputProps('machines')}
                          />
                        </FormInputWrapper> */}
        {/* {showStyleCodes ? (
                    <FormInputWrapper label='Styles' id='input-stylecodes' labelWidth={LABEL_WIDTH}>
                        <MultiSelect
                            data={styleCodes}
                            placeholder='All'
                            searchable
                            searchValue={styleCode}
                            onSearchChange={setStylecode}
                            nothingFound='Nothing found'
                            {...form.getInputProps('styles')}
                        />
                    </FormInputWrapper>
                ) : null} */}

        {filterFields.map((field) => (
          <Box key={field.value}>{filterField(field)}</Box>
        ))}

        {/* <FormInputWrapper label='Task Assigned' labelWidth={'120px'}>
                    <SegmentedControl
                        style={{ width: '100%' }}
                        data={[
                            { label: 'All', value: '' },
                            { label: 'Yes', value: '1' },
                            { label: 'No', value: '0' },
                        ]}
                        placeholder='Task Assigned'
                        {...form.getInputProps('status.taskAssigned')}
                    />
                </FormInputWrapper> */}

        {/* <FormInputWrapper label='Task Status' labelWidth={'120px'}> */}
        {/* <Select data={statuss} {...form.getInputProps('status')} /> */}
        {/* <MultiSelect
                        data={[{ label: 'Unassigned', value: 'unassigned' },...statuss.map((val) => {
                            const color = getColumnColor(val.value, 'value');
                            return { label: val.label, value: val.value, color: color };
                        })]}                       
                        placeholder='Select Status'
                        itemComponent={StatusSelectRenderer}
                        {...form.getInputProps('status.taskStatus')}
                    /> */}

        {/* <MultiSelect
                            data={styleCodes}
                            placeholder='All'
                            searchable
                            searchValue={styleCode}
                            onSearchChange={setStylecode}
                            nothingFound='Nothing found'
                            {...form.getInputProps('styles')}
                        /> */}

        {/* <SegmentedControl
                        style={{ width: '100%' }}
                        data={[
                            { label: 'All', value: '' },
                            { label: 'Yes', value: '1' },
                            { label: 'No', value: '0' },
                        ]}
                        placeholder='Task Complet'
                        {...form.getInputProps('status.taskStatus')}
                    /> */}
        {/* </FormInputWrapper> */}

        {/* <FormInputWrapper label='PSD Loaded' labelWidth={'120px'}>
                    <SegmentedControl
                        // style={{ width: '100%' }}
                        data={[
                            { label: 'All', value: '' },
                            { label: 'Yes', value: '1' },
                            { label: 'No', value: '0' },
                        ]}
                        placeholder='PSD Loaded'
                        {...form.getInputProps('psdLoaded')}
                    />
                </FormInputWrapper> */}
        <Divider />

        <Group justify="space-between" mt="lg">
          <Button
            variant="subtle"
            component="button"
            size="sm"
            onClick={() => onCancel()}
          >
            Cancel
          </Button>
          <Button type="submit" size="sm" variant="filled">
            Apply
          </Button>
        </Group>
      </form>
    </Box>
  );
};

export default CaptureFilterPanel;
